const API_BASE_URL = process.env.REACT_APP_API_URL || window.APP_CONFIG.REACT_APP_API_URL
// const REACT_APP_API_URL = window.APP_CONFIG.REACT_APP_API_URL;

const GET_API_PATH = {
    GET_URL_ORDERS: `${API_BASE_URL}/order/Orders`,
    GET_URL_UNSHIPPED_ORDERS: `${API_BASE_URL}/order/unShippedOrders`,

    GET_URL_ORDER_RULES: `${API_BASE_URL}/orderRule/getOrderRule`,

    GET_URL_DELIVER: `${API_BASE_URL}/employees/getDeliver`,

    GET_URL_DELIVERY_RECORD_BY_DELIVER: `${API_BASE_URL}/deliveryRecord/getDeliveryRecord`,

    GET_URL_DELIVER_ORDERS: `${API_BASE_URL}/deliverOrders/getDeliverOrders`,

    GET_URL_ADDRESS_OPTIONS: `${API_BASE_URL}/addressOptions/getAddressOptions`,

    GET_URL_COMPANIES: `${API_BASE_URL}/company/getCompanies`,

    // truckLoanApplication
    GET_URL_TRUCK_LOAN_APPLICATIONS: `${API_BASE_URL}/truckLoanApplication`,
    GET_URL_TRUCK_LOAN_PENDING: `${API_BASE_URL}/truckLoanApplication/pending`,
    GET_URL_TRUCK_LOAN_APPROVED: `${API_BASE_URL}/truckLoanApplication/approved`,
    GET_URL_TRUCK_LOAN_REJECTED: `${API_BASE_URL}/truckLoanApplication/rejected`,
    GET_URL_TRUCK_LOAN_RETURNED: `${API_BASE_URL}/truckLoanApplication/returned`,
    GET_URL_TRUCK_LOAN_APPLICATION_BY_ID: `${API_BASE_URL}/truckLoanApplication`,
    GET_URL_TRUCK_LOAN_APPLICATION_BY_DELIVER_ORDER_ID: `${API_BASE_URL}/truckLoanApplication/deliverOrder`,

    // notification
    GET_URL_NOTIFICATIONS: `${API_BASE_URL}/notification`,
    GET_URL_NOTIFICATION_UNREAD_COUNT: `${API_BASE_URL}/notification/unread-count`,
    GET_URL_NOTIFICATIONS_BY_ROLE: `${API_BASE_URL}/notification/role`,

}
export { GET_API_PATH }